import React from 'react';
import { motion } from 'framer-motion';
import SkillCategory from './SkillCategory';
import laboratorySkillsData from '../data/laboratorySkills.json';

const LaboratorySkills = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="py-16"
    >
      <h2 className="section-heading text-[#1e40af]">Laboratory Skills</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {laboratorySkillsData.skills.map((category, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="h-full"
          >
            <SkillCategory 
              title={category.title} 
              skills={category.items} 
              icon={category.icon}
            />
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
};

export default LaboratorySkills;
